angular.module('bmsApp.merrymaids.schedule', [])
	.config([
		'$stateProvider',
		function config($stateProvider) {

			$stateProvider

				.state('breakout.merrymaids.schedule', {
					url: '^/embedded/merrymaids/schedule',
					views: {
						'main@breakout': {
							templateUrl: 'ng/merrymaids/schedule/templates/embed/Schedule.html',
							controller: 'MMScheduleCtrl'
						}
					}
				})

				.state('main.merrymaids.schedule', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/merrymaids/schedule/templates/MMScheduleMain.html'
						}
					}
				})

				.state('main.merrymaids.schedule.calendar', {
					url: '^/merrymaids/schedule/calendar',
					views: {
						'content@main.merrymaids.schedule': {
							templateUrl: 'ng/merrymaids/schedule/calendar/templates/MMScheduleCalendar.html',
							controller: 'MMScheduleCalendarCtrl',
							controllerAs: 'Ctrl',
						}
					},
					ncyBreadcrumb: {
						label: 'Work Calendar'
					}
				})

				.state('main.merrymaids.schedule.daily', {
					url: '^/merrymaids/schedule/daily?date',
					views: {
						'content@main.merrymaids.schedule': {
							templateUrl: 'ng/merrymaids/schedule/templates/MMScheduleDaily.html',
							controller: 'MMScheduleDailyCtrl'
						}
					},
					ncyBreadcrumb: {
						label: 'Scheduling & Routing'
					}
				})

			;

		}
	]);
